import { PedigreeType } from './pedigree-type.enum';
import { Pedigree } from './pedigree';

/**
 * Parses the address details and returns a string.
 * @param obj
 */
export const parseAddress = (obj: any) => {
  // If no values exist, return a dash.
  if (!obj.addressLine && !obj.state && !obj.postcode) {
    return '—';
  }

  let address = '';
  if (obj.addressLine) {
    address += obj.addressLine;
    if (obj.state || obj.postcode) {
      address += ', ';
    }
  }
  if (obj.state) {
    address += obj.state;
    if (obj.postcode) {
      address += ' ';
    }
  }
  if (obj.postcode) {
    address += obj.postcode;
  }
  return address;
};

/**
 * Returns the phone number or `—` if not defined.
 * @param obj
 */
export const parsePhone = (obj: any) => obj.phone || '—';

/**
 * Returns the breeder and flock code if they exist, otherwise `—`.
 * @param obj
 */
export const parseBreeder = (obj: any) => (obj.breederName && obj.breedFlockCode ? `${obj.breederName} (${obj.breedFlockCode})` : '—');

/**
 * Gets the label for a pedigree type.
 * @param pedigree
 */
export const getPedigreeTypeLabel = (pedigree: PedigreeType) => {
  switch (pedigree) {
    case PedigreeType.Sire:
      return 'Sire';
    case PedigreeType.Dam:
      return 'Dam';
    default:
      return '';
  }
};

/**
 * Adds an "Unavailable" sire and dam to an animal.
 * @param pedigree
 */
export const addUnavailable = (pedigree: Pedigree) => {
  const p = { ...pedigree };
  p.children = [
    {
      animalId: '',
      studId: 'Unavailable',
      type: PedigreeType.Sire,
      typeLabel: getPedigreeTypeLabel(PedigreeType.Sire),
      isLinked: false,
      children: [],
    },
    {
      animalId: '',
      studId: 'Unavailable',
      type: PedigreeType.Dam,
      typeLabel: getPedigreeTypeLabel(PedigreeType.Dam),
      isLinked: false,
      children: [],
    },
  ];

  return p;
};
